import React from 'react';

export interface Props extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'custom';
  background?: 'light' | 'dark';
  variant?: 'text' | 'icon';
}

export interface Props extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'custom';
  background?: 'light' | 'dark';
  variant?: 'text' | 'icon';
}

export const CapturLogoSvg = ({
  width,
  height,
  size,
  background = 'light',
  variant = 'icon',
  ...other
}: Props) => {
  switch (size) {
    case 'sm': {
      width = 28;
      height = 28;
      break;
    }
    case 'md': {
      width = 160;
      height = 160;
      break;
    }
    case 'lg': {
      width = 320;
      height = 320;
      break;
    }
    default: {
      // use 32 as default;
      break;
    }
  }

  // Calculate dimensions for logo given width or height
  const logoWidthHeightRatio = variant === 'text' ? 138 / 32 : 1;
  const hasNoSizeDefined = variant === 'text' || !size;

  if (hasNoSizeDefined && height && !width) {
    width = height * logoWidthHeightRatio;
  }
  if (hasNoSizeDefined && !height && width) {
    height = width / logoWidthHeightRatio;
  }
  if (!height && !width) {
    width = 138;
    height = 32;
  }

  const fillColor = background === 'light' ? '#4B39E3' : '#ffffff';
  const blue1 = '#47BFE2';
  const blue2 = '#72EFDD';

  return variant === 'icon' ? (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.5245 -0.000976562H7.54272C5.54227 -0.000976562 3.62374 0.779672 2.20921 2.16923C0.794675 3.55879 0 5.44344 0 7.40857V24.5895C0 26.5546 0.794675 28.4393 2.20921 29.8288C3.62374 31.2184 5.54227 31.999 7.54272 31.999H27.3424V27.4445H7.54272C6.77086 27.4439 6.0308 27.1424 5.48501 26.6062C4.93922 26.0701 4.63233 25.3431 4.6317 24.5848V7.40395C4.63233 6.64572 4.93922 5.91871 5.48501 5.38256C6.0308 4.84641 6.77086 4.54493 7.54272 4.54432C9.71125 4.54432 11.8798 4.55822 14.0483 4.56053H27.3565V22.4754H32V-0.000976562H30.5245Z"
        fill={fillColor}
      />
      <path
        d="M9.14307 9.00391V15.0326H16.7518V22.5088H22.8873V9.00391H9.14307Z"
        fill={blue1}
      />
      <path
        d="M16.7518 15.0342H9.14307V22.5104H16.7518V15.0342Z"
        fill={blue2}
      />
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      viewBox="0 0 138 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.1195 7.93518C65.8959 6.59144 63.9228 5.81348 61.6365 5.81348C56.6469 5.81348 53.0247 9.55767 53.0247 14.6997C53.0247 19.8417 56.6617 23.6192 61.6725 23.6192C63.8593 23.6192 65.8874 22.7871 67.1195 21.4558V23.2676H71.2899V6.1671H67.1195V7.93518ZM62.0684 19.6982C59.3354 19.6982 57.1994 17.487 57.1994 14.6643C57.1994 11.8416 59.2952 9.73655 62.0684 9.73655C64.5325 9.73655 67.0835 11.5795 67.0835 14.6643C67.0835 17.9675 64.5601 19.6982 62.0684 19.6982Z"
        fill={fillColor}
      />
      <path
        d="M100.695 0H96.5267V6.16542H93.5143V9.69951H96.5267V23.2659H100.695V9.69951H104.281V6.16542H100.695V0Z"
        fill={fillColor}
      />
      <path
        d="M118.622 15.2996C118.622 18.4427 116.189 19.5576 114.108 19.5576C112.027 19.5576 110.634 18.0245 110.634 15.6511V6.16797H106.464V15.8945C106.445 18.3906 107.154 20.4271 108.513 21.7729C109.735 22.9814 111.477 23.62 113.535 23.62C114.976 23.62 117.29 23.0418 118.615 21.5212V23.2664H122.796V6.16797H118.626L118.622 15.2996Z"
        fill={fillColor}
      />
      <path
        d="M84.2424 5.81348C82.0365 5.81348 79.9958 6.64552 78.7616 7.97886V6.1671H74.5912V28.6634H78.7637V21.4974C79.9852 22.8412 81.9582 23.6192 84.2445 23.6192C89.2554 23.6192 92.8923 19.875 92.8923 14.735C92.8923 9.5951 89.2532 5.81348 84.2424 5.81348ZM83.819 19.6982C81.3527 19.6982 78.8039 17.8531 78.8039 14.7683C78.8039 11.4776 81.3866 9.70119 83.819 9.70119C86.5964 9.70119 88.688 11.8791 88.688 14.7683C88.6838 17.6243 86.6345 19.6982 83.8126 19.6982H83.819Z"
        fill={fillColor}
      />
      <path
        d="M134.172 5.81348V5.82804C132.379 5.9258 131.027 6.82233 130.135 8.50097V6.17125H125.929V23.2697H130.135V17.0294C130.135 14.8578 130.538 9.82599 134.238 9.77815H137.333V5.82596L134.172 5.81348Z"
        fill={fillColor}
      />
      <path
        d="M45.6795 9.70924C46.3921 9.7148 47.0962 9.86124 47.7499 10.1398C48.2045 10.3738 48.6397 10.6423 49.0518 10.9427L49.869 11.4773L52.1426 8.11588C52.1595 8.08676 50.5591 7.09039 50.4257 7.00719C49.4033 6.39356 48.2552 6.00996 47.064 5.88393C46.6432 5.82685 46.2186 5.80112 45.7938 5.80697H45.5715C43.5376 5.77252 41.5525 6.42122 39.9447 7.64578C37.6774 9.29738 36.4284 11.806 36.4284 14.6911C36.4284 17.5762 37.6795 20.0869 39.9383 21.7322C41.548 22.9583 43.5351 23.6084 45.5715 23.5752H45.7938C47.3451 23.5998 48.8765 23.2301 50.2395 22.5019L50.3961 22.4124C50.9952 22.0609 51.5647 21.649 52.1447 21.2684L49.8711 17.9152C49.888 17.9423 48.2961 18.9553 48.1394 19.0323C47.5156 19.3746 46.8267 19.587 46.1156 19.6563C45.978 19.6688 45.8383 19.6771 45.6922 19.6812C42.7412 19.6001 40.5988 17.5013 40.5988 14.689C40.5988 11.8767 42.7475 9.79036 45.6795 9.70924Z"
        fill={fillColor}
      />
      <path
        d="M27.4147 3.25293H6.77428C4.97763 3.25293 3.25456 3.95422 1.98414 5.20252C0.713714 6.45083 0 8.14389 0 9.90925V25.3436C0 27.109 0.713714 28.802 1.98414 30.0503C3.25456 31.2986 4.97763 31.9999 6.77428 31.9999H24.5568V27.9084H6.77428C6.08105 27.9078 5.41639 27.637 4.9262 27.1553C4.43602 26.6737 4.16039 26.0206 4.15983 25.3394V9.9051C4.16039 9.22394 4.43602 8.57084 4.9262 8.0892C5.41639 7.60755 6.08105 7.33672 6.77428 7.33617C8.72188 7.33617 10.6695 7.34865 12.6171 7.35073H24.5695V23.4445H28.7399V3.25293H27.4147Z"
        fill={fillColor}
      />
      <path
        d="M8.21159 11.3398V16.7543H15.0451V23.4689H20.5556V11.3398H8.21159Z"
        fill={blue1}
      />
      <path
        d="M15.0451 16.7549H8.21159V23.4695H15.0451V16.7549Z"
        fill={blue2}
      />
    </svg>
  );
};
